import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { RetrievalQueries } from "@faire/retailer/features/RetrievalQueries/RetrievalQueries";
export var SDUIRetrievalQueriesRenderer = function(param) {
    var filterableComponentsResponse = param.filterableComponentsResponse;
    var _componentWithRequestId_logging_data;
    var componentWithRequestId = filterableComponentsResponse === null || filterableComponentsResponse === void 0 ? void 0 : filterableComponentsResponse.components.find(function(component) {
        var _component_logging_data;
        return ((_component_logging_data = component.logging_data) === null || _component_logging_data === void 0 ? void 0 : _component_logging_data.request_id) !== undefined;
    });
    var requestId = componentWithRequestId === null || componentWithRequestId === void 0 ? void 0 : (_componentWithRequestId_logging_data = componentWithRequestId.logging_data) === null || _componentWithRequestId_logging_data === void 0 ? void 0 : _componentWithRequestId_logging_data.request_id;
    return /*#__PURE__*/ _jsx(RetrievalQueries, {
        allRetrievalQueries: filterableComponentsResponse === null || filterableComponentsResponse === void 0 ? void 0 : filterableComponentsResponse.retrieval_debug_info_queries,
        requestId: requestId
    });
};
